import { Stack } from '@mui/material'
import { BodyText, Notice, StepCard, StepTitle } from '../../components/ui'
import { OtrSampleDownload, OtrUpload } from '../../components/ImplementationUploads'

/** Design manual p.10 — Open Tax Report (OTR) Submission. */
export function StepOtr() {
  return (
    <StepCard>
      <StepTitle>Tax Transaction Report Submission</StepTitle>
      <Stack spacing={2.5}>
        <BodyText>Please submit a sample Open Tax Report (OTR).</BodyText>
        <Notice tone="warning">
          <strong>Important:</strong> A test Tax Transaction Report must be reviewed and approved by MISC before a Go-Live
          date can be scheduled.
        </Notice>
        <OtrSampleDownload />
        <OtrUpload />
        <BodyText sx={{ fontSize: 13, color: '#64748b' }}>
          Not ready yet? You can continue and submit the test OTR later from Next Steps.
        </BodyText>
      </Stack>
    </StepCard>
  )
}
